export class ClaimWithSourceAndNoteIds {
  RawDataImport_ShardClaimIdentifier: number;
  Source: string;
  NoteIds: number[];
}
